import { render, staticRenderFns } from "./PaymentIcon.vue?vue&type=template&id=181d1198&"
import script from "./PaymentIcon.vue?vue&type=script&lang=js&"
export * from "./PaymentIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1664913644/src/struxture-clientportal/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('181d1198')) {
      api.createRecord('181d1198', component.options)
    } else {
      api.reload('181d1198', component.options)
    }
    module.hot.accept("./PaymentIcon.vue?vue&type=template&id=181d1198&", function () {
      api.rerender('181d1198', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/invoices/InvoiceRenderer/PaymentIcon.vue"
export default component.exports